if (ENV == 'production') {
	console.log = function () { };
	// register ServiceWorker via OfflinePlugin, for prod only:
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.register('/assets/js/sw/sw.js');
	}
}

var GMTID = '';

let apphashes = window.apphashes || {};

function getFilename(key) {
	if (ENV == 'production') {
		return key + '.' + apphashes[key] + '.js';
	} else {
		return key + '.js';
	}
}

function getAppKey(key) {
	if (window.appKeys) {
		return window.appKeys[key] || null;
	}
	return null;
}

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
	// We execute the same script as before
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
});


import loader from 'loadjs';
//console.log(loader);
window.loader = loader;
//console.log(window.loader);
//window.loader = require('loadjs');
window.loader.config({
	livereload: {
		files: ['//localhost:9090/livereload.js?snipver=1']
	},
	jquery: {
		files: ['https://code.jquery.com/jquery-3.3.1.min.js']
	},
	popper: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.7/umd/popper.min.js']
	},
	bootstrap: {
		files: ['https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/js/bootstrap.min.js'],
		deps: ['jquery', 'popper']
	},
	gsap: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/gsap/1.20.4/TweenMax.min.js']
	},
	lodash: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.10/lodash.min.js']
	},
	moment: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.23.0/moment.min.js']
	},

	rangeSlider: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/ion-rangeslider/2.3.0/js/ion.rangeSlider.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/ion-rangeslider/2.3.0/css/ion.rangeSlider.min.css']
	},
	noUiSlider: {
		keys: ['https://cdnjs.cloudflare.com/ajax/libs/noUiSlider/11.1.0/nouislider.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/noUiSlider/11.1.0/nouislider.min.css']
	},
	cookies: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/js-cookie/2.1.4/js.cookie.min.js']
	},

	enquire: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/enquire.js/2.1.6/enquire.min.js']
	},
	uri: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/URI.js/1.19.1/URI.min.js']
	},
	address: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/jquery.address/1.6/jquery.address.min.js']
	},

	'numeral-core': {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/numeral.js/2.0.6/numeral.min.js']
	},
	numeral: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/numeral.js/2.0.6/locales/en-gb.min.js','https://cdnjs.cloudflare.com/ajax/libs/numeral.js/2.0.6/locales/es-es.min.js'],
		deps: ['numeral-core']
	},

	uniform: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/Uniform.js/4.2.2/js/jquery.uniform.bundled.js']
	},
	swiper: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.5.0/js/swiper.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.5.0/css/swiper.min.css']
	},
	slick: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js','https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css','https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css']
	},
	gumshoe: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/gumshoe/3.5.0/js/gumshoe.min.js']
	},
	smoothscroll: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/smooth-scroll/16.0.3/smooth-scroll.min.js']
	},
	scrollbar: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/malihu-custom-scrollbar-plugin/3.1.5/jquery.mCustomScrollbar.concat.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/malihu-custom-scrollbar-plugin/3.1.5/jquery.mCustomScrollbar.min.css'],
		deps: ['jquery']
	},
	picturefill: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/picturefill/3.0.3/picturefill.min.js']
	},
	lazysizes: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.1.0/lazysizes.min.js']
	},
	lazyload: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/vanilla-lazyload/12.0.0/lazyload.min.js']
	},
	matchheight: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/jquery.matchHeight/0.7.2/jquery.matchHeight-min.js'],
		deps: ['jquery']
	},
	'jquery-mask': {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/jquery.mask/1.14.15/jquery.mask.min.js'],
		deps: ['jquery']
	},
	ga: {
		files: ['https://www.google-analytics.com/analytics.js']
	},
	gtm: {
		files: ['https://www.googletagmanager.com/gtm.js?id=' + GMTID]
	},
	'ga-tracker': {
		files: ['/assets/js/' + getFilename('tracker')]
	},
	zxcvbn: {
		files: ['https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.4.2/zxcvbn.js']
	},

	braintree: {
		keys: ['braintree-client', 'braintree-hosted-fields', 'braintree-three-d-secure']
	},
	'braintree-client': {
		files: ['https://js.braintreegateway.com/web/3.32.1/js/client.min.js']
	},
	'braintree-hosted-fields': {
		files: ['https://js.braintreegateway.com/web/3.32.1/js/hosted-fields.min.js']
	},
	'braintree-three-d-secure': {
		files: ['https://js.braintreegateway.com/web/3.32.1/js/three-d-secure.min.js']
	},
	'braintree-dropinUI': {
		files: ['https://js.braintreegateway.com/web/dropin/1.42.0/js/dropin.min.js']
	},
	chart: { files: ['https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.7.2/Chart.min.js'] },
	datatables: {
		files: ['https://cdn.datatables.net/v/bs4/dt-1.10.20/sl-1.3.1/datatables.min.js', 'https://cdn.datatables.net/v/bs4/dt-1.10.20/sl-1.3.1/datatables.min.css'],
		deps: ['jquery']
	},
	maps: { files: ['https://maps.googleapis.com/maps/api/js?key=' + getAppKey('maps') + '&libraries=places'] },
	rateyo: { files: ['https://cdnjs.cloudflare.com/ajax/libs/rateYo/2.3.2/jquery.rateyo.min.js'], deps: ['jquery'] },

	aos: { files: ['https://unpkg.com/aos@2.3.1/dist/aos.js', 'https://unpkg.com/aos@2.3.1/dist/aos.css'] },

	twilio: {
		files: [
			'https://media.twiliocdn.com/sdk/js/common/v0.1/twilio-common.min.js',
			'https://media.twiliocdn.com/sdk/js/chat/releases/3.3.3/twilio-chat.min.js',
			'https:////media.twiliocdn.com/sdk/js/video/releases/2.3.0/twilio-video.min.js',
			'https://unpkg.com/interactjs/dist/interact.min.js'
		]
	},
	hotspots: {
		files: [
			'/assets/js/libraries/jquery-hotspot/jquery.hotspot.css',
			'/assets/js/libraries/jquery-hotspot/jquery.hotspot.js'
		]
	},
	plupload: {
		files: [
			'/assets/js/libraries/plupload/jquery.plupload.queue.css',
			'https://cdnjs.cloudflare.com/ajax/libs/plupload/2.3.6/plupload.full.min.js',
			'https://cdnjs.cloudflare.com/ajax/libs/plupload/3.1.2/jquery.plupload.queue/jquery.plupload.queue.min.js'
		],
		deps: ['jquery']
	},
	selectize: {
		files: [
			// 'https://cdnjs.cloudflare.com/ajax/libs/selectize.js/0.12.6/css/selectize.css',
			'https://cdnjs.cloudflare.com/ajax/libs/selectize.js/0.12.6/css/selectize.default.min.css',
			'https://cdnjs.cloudflare.com/ajax/libs/selectize.js/0.12.6/js/standalone/selectize.min.js'
		]
	},
	// annotorious: { files: ['/assets/js/libraries/annotorious/css/theme-dark/annotorious-dark.css', '/assets/js/libraries/annotorious/annotorious.min.js'] },
	// markerjs: { files: ['https://unpkg.com/markerjs'] },

	core: {
		keys: ['bootstrap', 'uri', 'cookies', 'smoothscroll', 'lazyload']
	}
});

if (ENV == 'development') {
	window.loader.key('livereload', function () {
		console.log('livereload');
	});
}

//import gtag from 'gtag-tracker';
if (GMTID) {
	var tracker = gtag(GMTID);
	//var tracker = require('gtag-tracker')(GMTID);
	window.loader.key('gtag', function () {
		console.log('gtag loaded');
	});
}

//import * as workerTimers from 'worker-timers';
//import workerTimers from 'worker-timers';
//var workerTimers = require('worker-timers');

import pad from './utils/pad';
import Btn from './utils/btn';

import findReplace from './utils/findReplace';
window.findReplace = findReplace;

window.xsBreakpoint = 576; //parseInt(window.getComputedStyle(document.body).getPropertyValue('--breakpoint-sm'));
window.smBreakpoint = 768;

import * as modules from './modules/**/*.js';
//console.log(modules);

import formValidation from './utils/form-validation';

//custom
import custom from './custom.js';

window.loader.key('core', function () {
	//console.log('core loaded');

	//global vars
	window.uri = new URI();
	window.$body = $('body');
	window.$window = $(window);

	if ($('.twilio.full-screen')[0]) {
		window.scrollTo(0, 1);
	}

	try {
		window.scroller = new SmoothScroll('a[href*="#"]', {
			offset: function (anchor, toggle) {
				var $kd45 = $('[data-kd-id="045"]');
				return ($kd45[0] ? $kd45.outerHeight() : 0);
			},
			speed: 1000,
			updateURL: false
		});
	} catch (err) {
		window.scroller = {
			animateScroll: function (pos) {
				window.scrollTo(0, pos);
			}
		};
	}
	//window.scroller = new SmoothScroll();

	//scroll on page load to hashes
	if (location.hash) {
		if ($(location.hash)[0]) {
			setTimeout(function () {
				var scrollPos = Number($(location.hash).offset().top);
				var offset = 10;
				$('.fixed-top-md').each(function () {
					offset += Number($(this).outerHeight());
				});
				scrollPos -= offset;
				scrollPos = Math.round(scrollPos);
				//console.log(scrollPos, window.$window.scrollTop());
				if (scrollPos != window.$window.scrollTop()) {
					window.scroller.animateScroll(scrollPos);
				}
			}, 10);
		}
	}

	$('a[href]').each(function () {
		var $this = $(this),
			$parent = $this.parent(),
			aUri = new URI($this.attr('href'));

		if (aUri.origin() && uri.origin() != aUri.origin()) {
			$this.attr('data-external', true);
		}

		if (uri == aUri && !$this.hasClass('btn')) {
			$this.addClass('active');
		}
	});

	$('header a').each(function () {

		var $this = $(this),
			$parent = $this.parent(),
			aUri = new URI($this.attr('href')),
			segmentKey = (uri.segment(0) == 'es' || uri.segment(0) == 'de') ? 1 : 0,
			uriSegment = uri.segment(segmentKey),
			segment = aUri.segment(segmentKey);

		// if(uri.segment(0) == 'es' || uri.segment(0) == 'de') {
		// 	segment = aUri.segment(1);
		// 	uriSegment = uri.segment(1);
		// }

		if (
			uriSegment && 
			(uriSegment.indexOf(segment) != -1) && 
			(!$this.hasClass('btn') && 
			($this.data('id') == 'main-nav'))
			) {
			$parent.addClass('active');
		}
	});

	$('[data-toggle="tooltip"]').tooltip();

	// caching
	
	jQuery(document).ready(function () {
		fetch("/actions/blitz/csrf/token")
			.then((response) => response.text())
			.then((csrfToken) => {
				$('[name="CRAFT_CSRF_TOKEN"]').val(csrfToken);
				window.csrfTokenValue = csrfToken;

				//load kd modules js
				$('[data-kd-id]').each(function () {
					var $this = $(this);
					if ('mod' + $this.data('kd-id') in modules) {
						modules['mod' + $this.data('kd-id')]($this);
					}
				});

				//load js modules
				$('[data-mod]').each(function () {
					var $this = $(this);
					if ($this.data('mod') in modules) {
						modules[$this.data('mod')]($this);
					}
				});
			})
			.catch((error) => {
				console.error("Failed to fetch CSRF token:", error);
			});
			
		$.ajax({
			url: "/actions/blitz/csrf/input",
			method: "GET",
		}).done(function (data) {
			$('input[type="hidden"][name="CRAFT_CSRF_TOKEN"]').each(function () {
				$(this).replaceWith($(data));
			});
		}).fail(function (error) {
			console.error("Failed to replace CSRF input:", error);
		});
    });

	// Refresh CSRF tokens after Sprig/htmx content is loaded
	// Enhanced for Blitz-cached pages where CSRF tokens may be stale
	
	function refreshCSRFTokens(target) {
		console.log('Refreshing CSRF tokens for target:', target);
		// Use the Blitz CSRF endpoint that we know works
		$.ajax({
			url: "/actions/blitz/csrf/input",
			method: "GET",
		}).done(function (data) {
			var $target = target ? $(target) : $(document);
			var $tokens = $target.find('input[type="hidden"][name="CRAFT_CSRF_TOKEN"]');
			console.log('Found', $tokens.length, 'CSRF tokens to replace');
			$tokens.each(function () {
				$(this).replaceWith($(data));
			});
			console.log('CSRF tokens refreshed successfully');
		}).fail(function (error) {
			console.error("Failed to replace CSRF input:", error);
		});
	}
	
	// Wait for htmx to be available, then add event listener
	function addHtmxListener() {
		if (typeof htmx !== 'undefined') {
			console.log('Adding htmx event listener for CSRF refresh');
			htmx.on('htmx:afterSwap', function(event) {
				console.log('htmx:afterSwap event fired for:', event.detail.target);
				// Small delay to ensure DOM is fully updated
				setTimeout(function() {
					refreshCSRFTokens(event.detail.target);
				}, 50);
			});
			
			// Also refresh on beforeRequest to ensure fresh tokens before submission
			htmx.on('htmx:beforeRequest', function(event) {
				console.log('htmx:beforeRequest event fired');
				// Only refresh if this is a form submission
				if (event.detail.xhr && event.detail.xhr.method === 'POST') {
					var $form = $(event.detail.target).closest('form');
					if ($form.length) {
						console.log('Refreshing CSRF before form submission');
						refreshCSRFTokens($form[0]);
					}
				}
			});
			
			// // Add interceptor for regular form submissions (not htmx)
			// $(document).on('submit', 'form[method="post"]', function(e) {
			// 	var $form = $(this);
				
			// 	// Check if this form is already being processed to prevent infinite loop
			// 	if ($form.data('csrf-refreshing')) {
			// 		console.log('Form already being processed, allowing submission');
			// 		return true;
			// 	}
				
			// 	// Only intercept if this form contains Sprig content
			// 	if ($form.find('.sprig-component').length > 0 || $form.closest('.sprig-component').length > 0) {
			// 		console.log('Intercepting form submission to refresh CSRF tokens');
			// 		e.preventDefault();
					
			// 		// Mark form as being processed
			// 		$form.data('csrf-refreshing', true);
					
			// 		// Refresh CSRF tokens then submit
			// 		$.ajax({
			// 			url: "/actions/blitz/csrf/input",
			// 			method: "GET",
			// 		}).done(function (data) {
			// 			var $tokens = $form.find('input[type="hidden"][name="CRAFT_CSRF_TOKEN"]');
			// 			console.log('Refreshing', $tokens.length, 'CSRF tokens before submission');
			// 			$tokens.each(function () {
			// 				$(this).replaceWith($(data));
			// 			});
			// 			// Now submit the form - the flag will prevent re-interception
			// 			$form[0].submit();
			// 		}).fail(function (error) {
			// 			console.error("Failed to refresh CSRF before submission:", error);
			// 			// Submit anyway - the flag will prevent re-interception
			// 			$form[0].submit();
			// 		}).always(function() {
			// 			// Clear the flag after a short delay to allow future submissions
			// 			setTimeout(function() {
			// 				$form.removeData('csrf-refreshing');
			// 			}, 100);
			// 		});
			// 	}
			// });
		} else {
			// Retry after a short delay
			setTimeout(addHtmxListener, 100);
		}
	}
	
	// Start trying to add the htmx listener
	addHtmxListener();
	
	// Additional refresh for Blitz-cached pages
	// Refresh CSRF tokens for any existing forms on page load
	setTimeout(function() {
		if ($('form[method="post"]').length > 0) {
			console.log('Blitz cache detected - refreshing CSRF tokens for existing forms');
			refreshCSRFTokens(document);
		}
	}, 500);


	formValidation();

	//all submit buttons
	$('button[type="submit"]:not([data-btn="false"]):not(.fui-btn)').each(function () {
		var $this = $(this),
			$btn = new Btn($this);
		$this.parents('form').on('submit', function (e) {
			$btn.process();
		});
	});

	//auto heights
	var $style = $('<style type="text/css"></style>').appendTo($body);
	$window.on('resize', function () {
		$style.html('@media (max-width: ' + window.xsBreakpoint + 'px) { [data-kd-autoheight] { min-height:calc(100vh - ' + ($('header').outerHeight() + 50) + 'px) !important; }}</style>');
	});

	var $cookie = $('#cookie-notification');
	if ($cookie) {
		if (!Cookies.get('cookieNotification')) {
			$cookie.removeClass('d-none');
		}
		$cookie.find('.btn').on('click', function (e) {
			e.preventDefault();
			Cookies.set('cookieNotification', true, { expires: 365 });
			$cookie.addClass('d-none');
		});
	}

	$('#languageModal').modal();

	// caching
	// var $tokens = $('input[type="hidden"][name="CRAFT_CSRF_TOKEN"]');
	// if ($tokens[0]) {
	// 	$.ajax({
	// 		url: '/actions/blitz/csrf/input',
	// 		method: 'get'
	// 	}).done(function(data) {
	// 		$tokens.each(function() {
	// 			$(this).replaceWith($(data));
	// 		});
	// 	});
	// }
	// $('input[type="hidden"][name="CRAFT_CSRF_TOKEN"]').each(function() {
	// 	var $input = $(this);
	// 	$.ajax({
	// 		url: '/actions/blitz/csrf/input',
	// 		method: 'get'
	// 	}).done(function(data) {
	// 		$input.replaceWith($(data));
	// 	});
	// });

	//lazyload
	window.lazyLoadImages = new LazyLoad({
		elements_selector: '[loading=lazy]',
		use_native: false,
		callback_enter: function (el) {
			if (!el.dataset.svg) {
				el.style.removeProperty('width');
				el.style.removeProperty('height');
			}

		}
	});

	window.lazyLoadBgImages = new LazyLoad({
		elements_selector: '.lazyBg'
		/*callback_enter: function(el){
            	el.classList.add('loaded')
            }*/
	});

	custom();

	$(window)
		.trigger('resize')
		.trigger('scroll');
});
